import React, { useId } from 'react'
import PropTypes from 'prop-types'

const EnvelopeFillIcon = React.forwardRef(function EnvelopeFillIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M12.03 12.77L23.89 4.3C23.6 3.54 22.88 3 22.02 3H2C1.15 3 0.429999 3.53 0.139999 4.28L12.03 12.77Z"></path>
        <path d="M12.03 15.23L0 6.64001V19C0 20.1 0.9 21 2 21H22.03C23.13 21 24.03 20.1 24.03 19V6.66001L12.03 15.23Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

EnvelopeFillIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

EnvelopeFillIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default EnvelopeFillIcon
